if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}


/*
  media-gallery.js
  Vanilla JS slider behavior for the Liquid product media gallery you provided.
  - Finds every <media-gallery> on the page and wires up next/prev buttons,
    thumbnail clicks, keyboard left/right, and the slide counter.
  - Respects data-step on buttons (e.g. data-step="3").
  - Uses existing classes/markup (slider__slide, thumbnail, slider-button--next/prev).

  Installation:
  1. Add this file to your Shopify theme assets (e.g. assets/media-gallery.js).
  2. Include it in the theme (before </body>) with:
     <script src="{{ 'media-gallery.js' | asset_url }}" defer></script>

  Notes:
  - The code doesn't change your Liquid markup; it discovers the rendered IDs
    like GalleryViewer-<section.id> and GalleryThumbnails-<section.id> automatically.
  - If you'd like smooth CSS transitions, add them to your .slider__slide
    (e.g. transition: transform 300ms ease;).
*/(function () {
  'use strict';

  function initGallery(gallery) {
    try {
      // find the viewer slides container inside this gallery
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]') || gallery.querySelector('.slider');
      const slidesContainer = viewer ? viewer.querySelector('.slider, .product__media-list') || viewer : gallery.querySelector('.product__media-list');
      if (!slidesContainer) return;

      const slides = Array.from(slidesContainer.querySelectorAll('.slider__slide'));
      if (!slides.length) return;

      // controls (there can be multiple prev/next buttons in the markup)
      const prevButtons = Array.from(gallery.querySelectorAll('.slider-button--prev'));
      const nextButtons = Array.from(gallery.querySelectorAll('.slider-button--next'));

      // thumbnails (optional)
      const thumbnailsContainer = gallery.querySelector('[id^="GalleryThumbnails-"]') || gallery.querySelector('.thumbnail-list');
      const thumbnailItems = thumbnailsContainer ? Array.from(thumbnailsContainer.querySelectorAll('.thumbnail-list__item')) : [];
      const thumbnailButtons = thumbnailItems.map(item => item.querySelector('.thumbnail') || item);

      // counter elements
      const counterCurrent = gallery.querySelector('.slider-counter--current');
      const counterTotal = gallery.querySelector('.slider-counter--total');

      // find initial active index
      let currentIndex = slides.findIndex(s => s.classList.contains('is-active'));
      if (currentIndex === -1) currentIndex = 0;

      // clamp helper
      function clamp(i) {
        return Math.max(0, Math.min(i, slides.length - 1));
      }

      function updateAriaForThumbnails(index) {
        thumbnailButtons.forEach((btn, i) => {
          if (!btn) return;
          if (i === index) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        });
      }

      // NEW: show/hide/disable prev & next buttons depending on current index
      function updateNavButtons(index) {
        const isFirst = index <= 0;
        const isLast = index >= slides.length - 1;

        prevButtons.forEach(btn => {
          // hide visually and mark as disabled for screen readers
          if (isFirst) {
            btn.style.display = 'none';
            btn.setAttribute('aria-hidden', 'true');
            btn.disabled = true;
          } else {
            btn.style.display = '';
            btn.removeAttribute('aria-hidden');
            btn.disabled = false;
          }
        });

        nextButtons.forEach(btn => {
          if (isLast) {
            btn.style.display = 'none';
            btn.setAttribute('aria-hidden', 'true');
            btn.disabled = true;
          } else {
            btn.style.display = '';
            btn.removeAttribute('aria-hidden');
            btn.disabled = false;
          }
        });
      }

      function showSlide(index, options = {}) {
        index = clamp(index);
        slides.forEach((slide, i) => {
          const isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        // scroll the slide into view if the layout allows horizontal scroll
        // use smooth behavior; browsers will ignore if not scrollable
        try {
          const activeSlide = slides[index];
          if (activeSlide && typeof activeSlide.scrollIntoView === 'function') {
            activeSlide.scrollIntoView({ block: 'nearest', inline: 'center', behavior: options.instant ? 'auto' : 'smooth' });
          }
        } catch (e) { /* ignore */ }

        // update thumbnails and counters
        if (counterCurrent) counterCurrent.textContent = String(index + 1);
        if (counterTotal) counterTotal.textContent = String(slides.length);
        if (thumbnailButtons.length) updateAriaForThumbnails(index);

        currentIndex = index;

        // NEW: update nav button visibility after setting currentIndex
        updateNavButtons(currentIndex);

        // dispatch a custom event if someone wants to listen
        gallery.dispatchEvent(new CustomEvent('mediaGallery:change', { detail: { index, slide: slides[index] } }));
      }

      function changeBy(step) {
        showSlide(currentIndex + step);
      }

      // wire prev buttons
      prevButtons.forEach(btn => {
        btn.addEventListener('click', (ev) => {
          ev.preventDefault();
          const ds = parseInt(btn.dataset.step, 10) || 1;
          changeBy(-Math.abs(ds));
        });
      });

      // wire next buttons
      nextButtons.forEach(btn => {
        btn.addEventListener('click', (ev) => {
          ev.preventDefault();
          const ds = parseInt(btn.dataset.step, 10) || 1;
          changeBy(Math.abs(ds));
        });
      });

      // thumbnails click -> jump to that index
      thumbnailButtons.forEach((btn, idx) => {
        if (!btn) return;
        btn.addEventListener('click', (ev) => {
          ev.preventDefault();
          showSlide(idx);
        });
      });

      // keyboard navigation when gallery is focused
      gallery.addEventListener('keydown', (ev) => {
        if (ev.key === 'ArrowLeft') {
          ev.preventDefault();
          changeBy(-1);
        } else if (ev.key === 'ArrowRight') {
          ev.preventDefault();
          changeBy(1);
        }
      });

      // click on thumbnails that are not direct .thumbnail buttons but li with data-target
      // support markup that uses data-target attributes to point to slide ids
      thumbnailItems.forEach((item, idx) => {
        item.addEventListener('click', (ev) => {
          // if click already handled by inner button, do nothing
          if (ev.target.closest('.thumbnail')) return;
          showSlide(idx);
        });
      });

      // initialize counters, active state, and nav button visibility
      if (counterTotal) counterTotal.textContent = String(slides.length);
      showSlide(currentIndex, { instant: true });

      // optional: expose methods on DOM node for external control
      gallery.mediaGallery = {
        showSlide: (i) => showSlide(i),
        next: () => changeBy(1),
        prev: () => changeBy(-1),
        getCurrentIndex: () => currentIndex,
        slides: slides
      };

    } catch (err) {
      // avoid breaking the rest of the page
      // console.error('media-gallery init failed', err);
    }
  }

  // initialize all galleries on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.querySelectorAll('media-gallery')).forEach(initGallery);
    });
  } else {
    Array.from(document.querySelectorAll('media-gallery')).forEach(initGallery);
  }
})();
